import { ReactComponent as Megaphone } from "assets/svg/megaphone.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const newReleaseAnnouncement: SurveyTemplate = {
  icon: <Megaphone />,
  title: "New Release Announcement",
  description:
    "Give fans the opportunity to sign up to be among the first to hear about a release.",
  templateId: "newReleaseAnnouncement",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "New Release Announcement",
        },
      },
      ...getContestDefaults(formState),
    },
    surveyQuestions: [
      {
        id: "text_1",
        type: "text",
        variants: { mobile: "Headline4", desktop: "Headline3" },
      },
    ],
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-sweeps---n-ff6398"
        : "pp-new-releas-cd4719",
    fields: [
      {
        name: "format",
        type: "radio",
        label: "What format is this release? (optional)",
        options: ["Single", "EP", "Album"],
        defaultValue: "",
      },
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
